import { ProductAttributeList, ProductAttributeEdit, ProductAttributeCreate } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

export default {
    pages: {
        ProductAttributeList,
        ProductAttributeEdit,
        ProductAttributeCreate,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name: 'productAttribute',
    icon: 'fa-clipboard-list',
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/ProductAttribute/index.ts